/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { chat } from '../fn/ecom-chat-api/chat';
import { Chat$Params } from '../fn/ecom-chat-api/chat';
import { ChatResponse } from '../models/chat-response';

@Injectable({ providedIn: 'root' })
export class EcomChatApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `chat()` */
  static readonly ChatPath = '/v1/api/ui/ecom/chat';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chat$Response(params: Chat$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatResponse>> {
    return chat(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chat(params: Chat$Params, context?: HttpContext): Observable<ChatResponse> {
    return this.chat$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChatResponse>): ChatResponse => r.body)
    );
  }

}
